"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.useRefReducer = useRefReducer;
var _react = require("react");
var _forceUpdate = require("./force-update.hook");
function useRefReducer(reducer, initialValue) {
  const ref = (0, _react.useRef)(initialValue);
  const forceUpdate = (0, _forceUpdate.useForceUpdate)();
  const getState = () => {
    return ref.current;
  };
  const dispatch = (action, shouldForceUpdate) => {
    let result = action;
    if (typeof action === 'function') {
      result = action(getState, dispatch);
    }
    if (result) {
      ref.current = reducer(ref.current, result);
    }
    if (shouldForceUpdate) {
      forceUpdate();
    }
  };
  return {
    dispatch,
    getState
  };
}